import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Input,
  ButtonDropdown,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Label,
  Badge,
  Button
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import cloudIcon from "../../assets/tables/cloudIcon.svg";
import funnelIcon from "../../assets/tables/funnelIcon.svg";
import optionsIcon from "../../assets/tables/optionsIcon.svg";
import printerIcon from "../../assets/tables/printerIcon.svg";
import searchIcon from "../../assets/tables/searchIcon.svg";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Pencil from "../../assets/tables/pencil.png";
import cross from "../../assets/tables/cross1.png";
import Yes from "../../assets/yes.png";
import No from "../../assets/no.png";
import { useHistory, Link, useParams } from 'react-router-dom';
import { atob } from 'atob';
import { css } from "@emotion/react";
import { ClockLoader } from "react-spinners";
import { MultiSelect } from "react-multi-select-component";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchIcon from "../../components/Icons/HeaderIcons/SearchBarIcon.js"
import * as XLSX from 'xlsx';
import Excelicon from "../../assets/ms-excel.svg"
import QRimg from "../../assets/qr1.png"








// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import MUIDataTable from "mui-datatables";
import moreIcon from "../../assets/tables/moreIcon.svg"; //

import s from "../tables/Tables.module.scss";
import mock from "../tables/mock.js";
import "../dashboard/Dashboard.css";
import "../../styles/tost.css"
import BaseAPI from '../../api/apiurl.js';

const User = function ({ match }) {

  const history = useHistory();
  const [firstTable] = useState(mock.firstTable);
  const [secondTable] = useState(mock.secondTable);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
  const [tableDropdownOpen, setTableMenuOpen] = useState(false); //
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const uniqueId = match.params.uniqueId;
  const historypencil = useHistory(); // edit page
  const localStorageContents = { ...localStorage };
  const [selectedItems, setSelectedItems] = useState([]);
  const [customerId, setCustomerId] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [userId, setUserId] = useState('');
  const [selectedId, setSelectedId] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isrejectModalOpen, setIsrejectModalOpen] = useState(false);
  const [itemIdToApprove, setItemIdToApprove] = useState(null);
  const [ItemIdToReject, setItemIdToReject] = useState(null);
  const [isdelet, setIsdelet] = useState(false);
  const [isdeletOpen, setIsdeletModalOpen] = useState(false);
  const [ItemIddelet, setIddelet] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [selectAll, setSelectAll] = useState(false); //checkbox select
  const [selectedItemscheck, setSelectedItemscheck] = useState([]) //checkbox select
  const [searchValue, setSearchValue] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrCodeData, setQrCodeData] = useState('');
  const [qrUserid, setQrUserid] = useState('');
  const [qrUsername, setQrUsername] = useState('');





  const pageSize = 10;
  const secondTablePagesCount = Math.ceil((Array.isArray(data) ? data.length : 0) / pageSize);
 
   const PaginationComponent = () => {
     const pagesToShow = 5;
 
     const startPage = Math.max(0, secondTableCurrentPage - Math.floor(pagesToShow / 2));
     const endPage = Math.min(secondTablePagesCount - 1, startPage + pagesToShow - 1);
 
     return (
       <Pagination className="pagination-with-border">
         <PaginationItem disabled={secondTableCurrentPage <= 0}>
           <PaginationLink
             onClick={(e) => setSecondTablePage(e, secondTableCurrentPage - 1)}
             previous
             href="#top"
           />
         </PaginationItem>
         {[...Array(endPage - startPage + 1)].map((_, i) => (
           <PaginationItem
             key={i}
             active={startPage + i === secondTableCurrentPage}
           >
             <PaginationLink onClick={(e) => setSecondTablePage(e, startPage + i)} href="#top">
               {startPage + i + 1}
             </PaginationLink>
           </PaginationItem>
         ))}
         <PaginationItem disabled={secondTableCurrentPage >= secondTablePagesCount - 1}>
           <PaginationLink
             onClick={(e) => setSecondTablePage(e, secondTableCurrentPage + 1)}
             next
             href="#top"
           />
         </PaginationItem>
       </Pagination>
     );
   };

  const sendApproval = (approvalValue, customerId, companyId, userId, itemId) => {
    // Replace this with your actual API call to send the approval value
    // For example:
    fetch(`${BaseAPI}mobile`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        customer_id: customerId,
        company_id: companyId,
        userid: userId,
        regapproval: approvalValue,
        id: itemId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the API response if needed
        fetchData();
        setIsModalOpen(false);
        setIsrejectModalOpen(false);
      })
      .catch((error) => {
        // Handle errors if needed
      });
  };

  const openModal = (itemId) => {
    setItemIdToApprove(itemId);
    setIsModalOpen(true);
  };

  const openRejectModal = (itemId) => {
    setItemIdToReject(itemId);
    setIsrejectModalOpen(true);
  };

  const openQrModal = (qrCodeData, username, userid) => {
    setQrCodeData(qrCodeData);
    setQrUsername(username);
    setQrUserid(userid);
    setQrModalOpen(true);
  };


  const closeQrModal = () => {
    setQrModalOpen(false);
  };


  const closeModal = () => {
    setIsModalOpen(false);
    setItemIdToApprove(null);
  };

  const closeRejectModal = () => {
    setIsrejectModalOpen(false);
    setItemIdToReject(null);
  };

  const closedelet = () => {
    setIsdeletModalOpen(false);
    setIddelet(null);
  };

  const getMobileappText = (value, itemId) => {
    const handleApprovalClick = () => {
      openModal(itemId);
    };
    const handleApprovalClick2 = () => {
      console.log('itemId:', itemId);
      openRejectModal(itemId);
    };
    if (value === 0) {
      return (
        <div>
          <img
            className='zoom-in-icone'
            src={Yes}
            alt="yes"
            style={{ width: '20px', height: '20px', cursor: 'pointer' }}
            onClick={handleApprovalClick}
          />
          &nbsp;&nbsp;
          <img
            className='zoom-in-icone'
            src={No}
            alt="no"
            style={{ width: '20px', height: '20px', cursor: 'pointer' }}
            onClick={handleApprovalClick2}
          />
        </div>
      );
    } else if (value === 1) {
      return (
        <Badge style={{ backgroundColor: 'green', color: 'white' }}>
          Approved
        </Badge>
      );
    } else if (value === -1) {
      return (
        <Badge style={{ backgroundColor: 'red', color: 'white' }}>
          Rejected
        </Badge>
      );
    } else {
      return "Unknown"; // or any other fallback value
    }
  };


  const getStatusText = (value) => {
    if (value === 1) {
      return "Admin";
    } else if (value === 0) {
      return "User";
    } else {
      return "Unknown"; // or any other fallback value
    }
  }


  // const handleCheckboxChange = (e, itemId) => {
  //   const isChecked = e.target.checked;

  //   if (isChecked) {
  //     setSelectedId(prevSelectedItems => [...prevSelectedItems, itemId]);
  //   } else {
  //     setSelectedId(prevSelectedItems => prevSelectedItems.filter(id => id !== itemId));
  //   }
  // };

  const handleCheckboxChange = (e, id) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter(item => item !== id));
    }
  };

  // Function to handle header checkbox change
  const handleSelectAllChange = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      // Select all items
      const allIds = data.map(item => item.id);
      setSelectedItems(allIds);
    } else {
      // Deselect all items
      setSelectedItems([]);
    }
  };



  // const handleCheckboxChange = (e, itemId) => { // check box selection code
  //   if (e.target.checked) {
  //     setSelectedItems([...selectedItems, itemId]);
  //   } else {
  //     setSelectedItems(selectedItems.filter(id => id !== itemId));
  //   }
  // };


  const handlePrintClick = () => {
    if (selectedItems.length === 0) {
      // Display an alert message if no items are selected
      toast.warning('Please select items after QR codes to print.', {
        autoClose: 1500,
        position: 'top-center',
        className: 'custom-toast-warning', // Apply the custom error class

      });

      return; // Exit the function
    }

    // Create a new window and populate it with the printable content
    const printWindow = window.open('', '_blank');
    const printDocument = printWindow.document;

    // Add CSS to center-align the rows
    const style = printDocument.createElement('style');
    style.textContent = `
    .item-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;
    }
  `;
    printDocument.head.appendChild(style);

    // Create a "Print" button
    const printButton = printDocument.createElement('button');
    printButton.textContent = 'Print';
    printButton.onclick = () => {
      printWindow.print();
    };

    // Create a "Cancel" button
    const cancelButton = printDocument.createElement('button');
    cancelButton.textContent = 'Cancel';
    cancelButton.onclick = () => {
      printWindow.close();
    };

    printDocument.body.appendChild(printButton);
    printDocument.body.appendChild(cancelButton);

    selectedItems.forEach(itemId => {
      const selectedItem = data.find(item => item.id === itemId);
      const itemContainer = printDocument.createElement('div');
      itemContainer.className = 'item-container';

      const idElement = printDocument.createElement('div');
      idElement.textContent = `Staff Id: ${selectedItem.staff_id}`;
      itemContainer.appendChild(idElement);

      if (decodeBase64SVG(selectedItem.qrcode)) {
        const svgElement = printDocument.createElement('div');
        svgElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">${decodeBase64SVG(selectedItem.qrcode)}</svg>`;
        itemContainer.appendChild(svgElement);
      } else {
        const noDataElement = printDocument.createElement('div');
        noDataElement.textContent = 'No QR code data available.';
        itemContainer.appendChild(noDataElement);
      }

      const usernameElement = printDocument.createElement('div');
      usernameElement.textContent = `Username: ${selectedItem.username}`;
      itemContainer.appendChild(usernameElement);

      // ... Create and append other elements ...

      printDocument.body.appendChild(itemContainer);
    });
  };






  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  }

  const tableMenuOpen = () => {
    setTableMenuOpen(!tableDropdownOpen);
  } //

  const handleClickUserAdd = () => {
    history.push('/timeinlive/Useradd');
  };



  // const fetchData = () => {
  //   fetch(`${BaseAPI}views`)
  //     .then((response) => response.json())
  //     .then((actualData) => {
  //       console.log(actualData);
  //       setData(actualData.data);
  //       console.log(data);
  //     })
  //     .catch((err) => {
  //       console.log(err.message);
  //     });
  // };

  const decodeBase64SVG = (base64Data) => {
    try {
      return decodeURIComponent(escape(window.atob(base64Data)));
    } catch (error) {
      console.error('Error decoding Base64 SVG:', error);
      return null;
    }
  };

  const fetchData = () => {

    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');

    const role = localStorage.getItem('role');


    const isRoleTwo = role === '2';
  

    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }

    const url = `${BaseAPI}views`;
    // const url = '${BaseAPI}views';
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: customerId, company_id: companyId })
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((actualData) => {
        console.log(actualData);

        setData(actualData.data);
        console.log("response", data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleEditClick = () => {
    // Replace `uniqueId` with the actual unique ID value
    history.push(`/timeinlive/Useradd/`);
  };


  const handleDelete = (id) => {
    // Set the item ID to delete in state
    setIddelet(id);
    // Open the delete confirmation modal
    setIsDeleteModalOpen(true);

    if (isDeleteModalOpen) {
      // Make a DELETE request to the API endpoint
      axios.get(`${BaseAPI}staffdelete/${id}`)
        .then((response) => {
          fetchData();
         
        })
        .catch((error) => {

        });
    }
  };

  const handleDownloadExcel = () => {
    // Prepare the data to export to Excel. You need to create an array of arrays (2D array).
    const excelData = [
      ['Id', 'User Name', 'Email', 'Mobile', 'Status'],
      ...filteredData.map((item) => [
        item.staff_id,
        // decodeBase64SVG(item.qrcode) ? `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" style="width: 50px; height: 50px;">${decodeBase64SVG(item.qrcode)}</svg>` : 'No QR code data available.',
        item.username,
        item.email,
        item.mobileno,
        getStatusText(item.status),
        // getMobileappText(item.regapproval, item.id),
      ]),
    ];

    // Create a worksheet from the data
    const ws = XLSX.utils.aoa_to_sheet(excelData);

    // Create a workbook with the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Users');

    // Generate a download link for the Excel file
    XLSX.writeFile(wb, 'user_data.xlsx');
  };


  useEffect(() => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');
    const userId = localStorage.getItem('userid');
    if (customerId) {
      setCustomerId(customerId);
    }
    if (companyId) {
      setCompanyId(companyId);
    }
    if (userId) {
      setUserId(userId);
    }
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(loadingTimeout), fetchData();
  }, []);

  useEffect(() => {
    // Implement the filter logic here
    const filteredItems = data.filter(item => {
      return (
        item.username.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.email.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.mobileno.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.staff_id.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.mobileno.toLowerCase().includes(searchValue.toLowerCase())
      );
    });

    setFilteredData(filteredItems);
  }, [data, searchValue]);


  console.log("setQrUsername", qrUsername);


  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <ClockLoader color={"#4e73df"} loading={isLoading} css={spinnerStyle} size={100} />
        </div>
      ) : (
        <div>
          <br/>
          <Row>
            <Col>
              <Row className="mb-4">
                <Col>
                  <Widget>
                    <div style={{ padding: "20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                         <div className="headline-2" style={{color : "blue"}}>User</div> &nbsp; &nbsp;
                        <label htmlFor="searchUser" className="sr-only">
                          Search User
                        </label>
                        <div className="col-sm-10 input-group">
                          <Input
                            type="text"
                            id="searchUser"
                            placeholder="Search..."
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            style={{ width: '150px' }}
                            className="focus form-control custom-input-group-text" // Apply Bootstrap form control class
                          />
                          <div className="input-group-append">
                            <span className="password-toggle input-group-text" > <SearchIcon /></span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <img
                          src={Excelicon}
                          type="button"
                          onClick={handleDownloadExcel}
                          width="40"  // Adjust the width to your desired size
                          height="40"
                          className="hover-animation"
                        />

                        &nbsp;  &nbsp;  &nbsp;
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{ fontSize: "15px", padding: "5px 20px" }}
                          onClick={handlePrintClick}
                        >
                          <i className="fa fa-print" />&nbsp; Print
                        </button>  &nbsp; &nbsp;
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{ fontSize: "15px", padding: "5px 20px" }}
                          onClick={handleClickUserAdd}
                        >
                          &nbsp;<i className="fa fa-plus-circle" />&nbsp;Add&nbsp;
                        </button>
                      </div>
                    </div>


                    {/* <div className="text-right">
  <input
    type="text"
    placeholder="Search..."
    value={searchValue}
    onChange={(e) => setSearchValue(e.target.value)}
    className="focus" // Apply Bootstrap form control class
  />
</div> */}

                    <div className="table-responsive-sm">
                      <div className="widget-table-overflow">
                        <Table className="table-striped table-borderless table-hover" responsive style={{ overflow: 'scroll', width: "100%" }}>
                          <thead>
                            <tr style={{ whiteSpace: 'nowrap' }}>
                              <th>
                                <div className="checkbox-primary">
                                  <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                  />
                                </div>
                              </th>
                              <th>Id</th>
                              <th>QR Code</th>
                              <th>User Name</th>
                              <th>Email</th>
                              <th>Mobile</th>
                              <th>Status</th>
                              <th>Mobile App</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredData && filteredData.length > 0 ? (
                              filteredData
                                .slice(secondTableCurrentPage * pageSize, (secondTableCurrentPage + 1) * pageSize)
                                .map((item, index) => (
                                  <tr key={index.id}>
                                    <td>
                                      <input
                                        id={item.id}
                                        className="styled"
                                        type="checkbox"
                                        checked={selectedItems.includes(item.id)}
                                        onChange={e => handleCheckboxChange(e, item.id)}
                                      />

                                    </td>
                                    <td>{item.staff_id}</td>
                                    <td className='hover-animation'>
                                      {/* Add the decoded SVG QR code
                                      {decodeBase64SVG(item.qrcode) ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" style="width: 50px; height: 50px;">${decodeBase64SVG(item.qrcode)}</svg>`,
                                          }}
                                        />
                                      ) : (
                                        <span>No QR code data available.</span>
                                      )} */}

                                      <img
                                        src={QRimg}
                                        alt="QR Code"
                                        type="button"
                                        onClick={() => openQrModal(item.qrcode, item.username, item.staff_id)}
                                        style={{ height: "60px", width: "60px" }}
                                      />
                                    </td>
                                    <td>{item.username}</td>
                                    <td>{item.email}</td>
                                    <td>{item.mobileno}</td>
                                    {/* <td>{item.imeino}</td> */}
                                    <td>{getStatusText(item.status)}</td>
                                    <td>{getMobileappText(item.regapproval, item.id)}</td>

                                    <td>
                                      {/* <a href={`/timeinlive/Useradd/`} onClick={() => handleEditClick(item.id)}>
          <img src={Pencil} alt="edit" style={{ width: '20px', height: '20px' }} />
        </a> &nbsp; */}
                                      <Link to={`/timeinlive/Useredit/${item.id}`}>
                                        <img src={Pencil} alt="edit" style={{ width: '21px', height: '21px' }} className='zoom-in-icone' />
                                      </Link> &nbsp;
                                      <a onClick={() => handleDelete(item.id)}>
                                        <img src={cross} alt="delet" style={{ width: '21px', height: '21px' }} className='zoom-in-icone' />
                                      </a>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="9" style={{ textAlign: "center", color: "red" }}>
                                  No data available
                                </td>
                              </tr>
                            )}

                          </tbody>

                        </Table>
                        <div style={{ textAlign: "left", marginTop: "20px" }}>
                          <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                            Total Users: <span style={{ color: "blue" }}>{data ? data.length : 0}</span>
                          </p>
                        </div>
                        <PaginationComponent />

                      </div>
                    </div>
                  </Widget>
                </Col>
              </Row>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      )}
      <Modal isOpen={isModalOpen} toggle={closeModal}>
        <ModalHeader toggle={closeModal} style={{ color: "green" }}>Approval Confirm Message</ModalHeader>
        <ModalBody>Do you want Approval?</ModalBody>
        <ModalFooter>
          <button className="btn btn-success" onClick={() => sendApproval(1, customerId, companyId, userId, itemIdToApprove)}>
            Approval
          </button>
          <button className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={isrejectModalOpen} toggle={closeRejectModal}>
        <ModalHeader toggle={closeRejectModal} style={{ color: "red" }}>Rejected Confirm Message</ModalHeader>
        <ModalBody>Do you want Rejected?</ModalBody>
        <ModalFooter>
          <button className="btn btn-danger" onClick={() => sendApproval(-1, customerId, companyId, userId, ItemIdToReject)}>
            Reject
          </button>
          <button className="btn btn-secondary" onClick={closeRejectModal}>
            Cancel
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(false)}>
        <ModalHeader toggle={() => setIsDeleteModalOpen(false)} style={{ color: "red" }}>Delete Confirmation</ModalHeader>
        <ModalBody>Are you sure you want to delete this item?</ModalBody>
        <ModalFooter>
          <button className="btn btn-danger" onClick={() => {
            // Call your delete function here
            handleDelete(ItemIddelet);
            // Close the modal
            setIsDeleteModalOpen(false);
          }}>
            Delete
          </button>
          <button className="btn btn-secondary" onClick={() => setIsDeleteModalOpen(false)}>
            Cancel
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={qrModalOpen} toggle={closeQrModal}>
        <ModalHeader toggle={closeQrModal}>QR Code Preview</ModalHeader>
        <div className="qr-user-info" style={{ textAlign: "center", padding: "10px", color: "red", fontFamily: "Arial, Helvetica, sans-serif" }}>
          <div className="qr-username">User Name: {qrUsername}</div>
          <div className="qr-userid">User ID: {qrUserid}</div>
        </div>
        <ModalBody>
          {decodeBase64SVG(qrCodeData) ? (
            <div
              dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" style="width: 100%; height: auto; display: block;" viewBox="-10 0 120 120" >${decodeBase64SVG(qrCodeData)}
          
          </svg>`,
              }}
            />
          ) : (
            <span>No QR code data available.</span>
          )}

        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={closeQrModal}>
            Close
          </button>
        </ModalFooter>
      </Modal>


    </div>
  )
}

const spinnerStyle = css`
display: block;
margin: 0 auto;
`;
export default User;
